module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "step__container"
  }, [_c('div', {
    ref: "title",
    staticClass: "step__title"
  }, [_c('p', [_vm._v("Please make your Ohana account.")])]), _vm._v(" "), _c('form', {
    ref: "form",
    staticClass: "step__form"
  }, [_c('InputField', {
    attrs: {
      "title": "FULL NAME",
      "type": "name",
      "placeholder": "First Last",
      "autocomplete": "name",
      "autocapitalize": "words",
      "disabled": false,
      "errored": false,
      "validated": _vm.nameValid,
      "errorMessage": ""
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _vm._v(" "), _c('InputField', {
    attrs: {
      "title": "EMAIL",
      "type": "email",
      "placeholder": "email@hello.com",
      "autocomplete": "email",
      "autocapitalize": "off",
      "disabled": false,
      "errored": false,
      "validated": _vm.emailValid,
      "errorMessage": _vm.emailErrorMessage
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('InputField', {
    attrs: {
      "title": "PASSWORD",
      "type": "password",
      "placeholder": "password",
      "disabled": false,
      "errorMessage": "",
      "validated": _vm.passwordValid
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('div', {
    ref: "button",
    staticClass: "step__button"
  }, [_c('a', {
    staticClass: "button",
    class: {
      'button--disable': (!_vm.isValid())
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goNextStep($event)
      }
    }
  }, [_c('span', [_vm._v("Create Account")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step__form-links"
  }, [_c('p', [_vm._v("By creating an account you agree to our "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://ohanaisfamily.com/privacy-policy.html",
      "target": "_blank"
    }
  }, [_vm._v("Privacy Policy")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "https://ohanaisfamily.com/terms-and-conditions.html",
      "target": "_blank"
    }
  }, [_vm._v("Terms of Use.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1dbaaabc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/2-blocks/Step2_MakeAcc.vue
// module id = 533
// module chunks = 1